// services/image-cache.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageCacheService {
  private cacheName = 'google-avatar-cache-v1';

  private isLocalAsset(url: string): boolean {
    if (!url) return true;
    
    // Controlla percorsi relativi o assoluti verso la cartella assets
    const cleanUrl = url.trim().toLowerCase();
    return (
      cleanUrl.startsWith('assets/') ||
      cleanUrl.startsWith('/assets/') ||
      cleanUrl.startsWith('./assets/') ||
      cleanUrl.startsWith('data:') || // Evita fetch anche su immagini in base64
      !cleanUrl.startsWith('http')    // Qualsiasi path relativo locale
    );
  }

  async getImageBlobUrl(url: string): Promise<string> {
    // Se è un asset locale o base64, ritorna subito il path senza fetch
    if (this.isLocalAsset(url)) {
      return url;
    }

    if (!('caches' in window)) {
      return url;
    }

    try {
      const cache = await caches.open(this.cacheName);
      const cachedResponse = await cache.match(url);

      if (cachedResponse) {
        const blob = await cachedResponse.blob();
        return URL.createObjectURL(blob);
      }

      // Fetch solo per URL remoti (es. lh3.googleusercontent.com)
      const networkResponse = await fetch(url, { mode: 'cors' });
      
      if (!networkResponse.ok) {
        throw new Error(`HTTP error: ${networkResponse.status}`);
      }

      await cache.put(url, networkResponse.clone());
      const blob = await networkResponse.blob();
      return URL.createObjectURL(blob);
    } catch (err) {
      console.warn('Errore nel recupero o caching immagine remota:', err);
      return url; // Fallback all'URL diretto in caso di errore
    }
  }
}